import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center text-lg-start mt-5" }
const _hoisted_2 = { class: "text-center p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("footer", _hoisted_1, [
    _createVNode("div", _hoisted_2, " © " + _toDisplayString($options.year) + " Bagrat Saatsazov ", 1)
  ]))
}